import { useTranslations } from 'next-intl'

import { Card } from '@/entities/auth'
import { TTermsForm } from '@/features/sign-up'
import { Slot } from '@/shared/lib'

import { TermsForm } from './terms-form'

type Props = {
  onSubmit: (formValues: TTermsForm) => void
  defaultValues?: TTermsForm
  onFormFieldChange: (formValues: TTermsForm) => void
}

export const SignUpTerms = ({
  onSubmit,
  defaultValues,
  onFormFieldChange,
}: Props) => {
  const t = useTranslations('signup_terms')

  return (
    <Card progress={25}>
      <Slot name="title">{t('title')}</Slot>
      <Slot name="children">
        <TermsForm
          onSubmit={onSubmit}
          defaultValues={defaultValues}
          onFormFieldChange={onFormFieldChange}
        />
      </Slot>
    </Card>
  )
}
